<div class="commerical-page">
    <nav class="navbar navbar-expand-md navbar-dark bg-dark bckGroundclr" id="navbarhead">
      <div class="sectpad container-fluid">
          <!-- <a class="navbar-brand logomain logomainpge" href="javascript:void(0)">
              <img src="assets/images/logoheadpink.png" height="71" class="logo drag-drop">
              <img src="assets/images/logotxtpink.png" height="71" class="logo drag-drop">
              <img src="assets/images/logo-mbl.png" class="logo1"></a> -->
          <a class="navbar-brand logomain logomainpge" href="javascript:void(0)" href="#/commercial">
              <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491666/Static%20images/Logo/honestgorilla-logo-black_hx8ekn.svg" alt="Honest Gorilla combo logo in blank" title="Black Honest Gorilla combo logo with Eva face" width="220" height="60" class="logo logohead drag-drop" alt="Honest Gorilla">
              <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491829/Static%20images/Logo/honestgorilla-title-black_ux1q8j.svg" alt="Honest Gorilla logo in black" title="Black Honest Gorilla logo" class="logo1 mt-2"></a>
          <button (click)="addClass($event)" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault"
              aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
              <img src="assets/images/list-charcoal.png" width="18"  id="menuIcon" class="listicn">
          </button>
          <div class="collapse navbar-collapse" id="navbarsExampleDefault">
              <ul class="navbar-nav ml-auto webnav">
                  <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0)" (click) ="mobileHeaderClick('residential')">RESIDENTIAL</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" (click) ="mobileHeaderClick('faq')" href="javascript:void(0)">FAQ</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)" (click) ="mobileHeaderClick('blog')">BLOG</a>
                </li>
                  <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0)" (click) ="mobileHeaderClick('giveback')">GIVEBACK</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="javascript:void(0)" (click) ="mobileHeaderClick('faq/contact-us')">CONTACT US</a>
                </li> 
                  
                <li class="nav-item" *ngIf='!showLogin'>
                    <a class="nav-link" href="javascript:void(0)" (click) ="gotoProfile()">PROFILE</a>
                </li> 
                  


                  
    
              </ul>
              

              <div class="mobilenav" *ngIf="!showLogin">
                <!-- <div class="col-12 row m-0">
                    <div class="col-6 col-md mt-4 mb-2  pl-0">
                        <a class="btn btn-outline-primary loginmobile w-100" href="javascript:void(0)" routerLink="/login">LOGIN</a>
                    </div>
                    <div class="col-6 col-md mt-4 mb-2 pr-0">
                        <a href="javascript:void(0)" class="btnsec w-100 font14" routerLink="/getstarted">SHOP NOW</a>
                    </div>
                </div> -->
                <div class="col-12 row m-0 p-0">
                    <div class="col-6 col-md mb-2 mt-2">
                        <h5 class="font16 semi-bold" (click) ="navigatee('/')">Residential</h5>
                    </div>
      
                    <div class="col-6 col-md mb-2 mt-2">
                        <h5 class="font16 semi-bold" (click) = "navigatee('/faq/contact-us')">Contact us</h5>
                    </div>
                  
      
                   
                    
                </div>
                <div class="col-12 row m-0 p-0">
                    <div class="col-6 col-md mb-2 mt-2">
                        <h5 class="font16 semi-bold" (click) = "navigatee('/faq')">FAQ</h5>
                    </div>
                    <div class="col-6 col-md mb-2 mt-2"  *ngIf="!showLogin">
                        
                        <h5 class="font16 semi-bold"  (click) = "gotoProfile()">Profile</h5> 
                   </div>
      
                   
                   
                </div>
                <div class="col-12 row m-0 p-0">
                    <div class="col-6 col-md mb-2 mt-2">
                        <h5 class="font16 semi-bold" (click) = "navigatee('/blog')">Blog</h5>
                    </div>
      
                    <div class="col-6 col-md mb-2 mt-2"  *ngIf="!showLogin">
                        
                        <h5 class="font16 semi-bold" (click) = 'gotologout()' routerLink="/">Logout</h5> 
                   </div>
                   <!-- <div class="col-6 col-md mb-2 mt-2"  *ngIf="showLogin">
                       
                       <h5 class="font16 semi-bold"  routerLink="/login">Login</h5> 
                  </div> -->
                   <div class="col-6 col-md mb-2 pt-1 mt-2">
                     
                    <h5 class="font16 semi-bold" (click) = "navigatee('/giveback')" >Giveback</h5>
                </div>
      
                <div class="col-6 col-md mb-2 mt-2 p-0">
                    <a href="javascript:void(0)" class="btnsec  font14" (click) = "navigatee('/commercial/questionnaire')">SHOP NOW</a>
                </div>
                </div>
      
      
                <div class="col-12 row m-0 p-0">
      
                  
                </div>
      
                
      
                <!-- <div class="col-12 row m-0 p-0">
                    <div class="col-4 col-md mb-2 mt-2 p-0">                      
                        <a class="btn btn-yw-primary mr-2 ml-2" routerLink="/get-started" >SHOP NOW</a>
                    </div>
                </div> -->
      
            </div>
      
            <div class="mobilenav" *ngIf="showLogin">
                <!-- <div class="col-12 row m-0">
                    <div class="col-6 col-md mt-4 mb-2  pl-0">
                        <a class="btn btn-outline-primary loginmobile w-100" href="javascript:void(0)" routerLink="/login">LOGIN</a>
                    </div>
                    <div class="col-6 col-md mt-4 mb-2 pr-0">
                        <a href="javascript:void(0)" class="btnsec w-100 font14" routerLink="/getstarted">SHOP NOW</a>
                    </div>
                </div> -->
                <div class="col-12 row m-0 p-0">
                    <div class="col-6 col-md mb-2 mt-2">
                        <h5 class="font16 semi-bold" (click) = "navigatee('/')">Residential</h5>
                    </div>
                    <div class="col-6 col-md mb-2 mt-2">
                        <!-- <h5 class="font18" routerLink="/about">About</h5>
                        <a class="nav-link aboutshop p-0 font16 abtmbl semi-bold" href="#shopSection" (click)="mobhead($event)">About</a> -->
                        <h5 class="font16 semi-bold" (click)="navigatee('/giveback')" >Giveback</h5>
                    </div>
      
                   
                    
                </div>
                <div class="col-12 row m-0 p-0">
                    <div class="col-6 col-md mb-2 mt-2">
                        <h5 class="font16 semi-bold" (click)="navigatee('/faq')">FAQ</h5>
                    </div>
                    <div class="col-6 col-md mb-2 mt-2">
                        <h5 class="font16 semi-bold" (click)="navigatee('/faq/contact-us')">Contact us</h5>
                    </div>
                   
                   
                </div>
                <div class="col-12 row m-0 p-0">
                    <div class="col-6 col-md mb-2 mt-2">
                        <h5 class="font16 semi-bold" (click)="navigatee('/blog')">Blog</h5>
                    </div>
      
                    <div class="col-6 col-md mb-2 mt-2"  *ngIf="!showLogin">
                        
                        <h5 class="font16 semi-bold"  (click) = "gotoProfile()">Profile</h5> 
                   </div>
      
                   <!-- <div class="col-6 col-md mb-2 mt-2"  *ngIf="showLogin">
                       
                    <h5 class="font16 semi-bold"  (click)="navigatee('/login')">Login</h5> 
               </div> -->
      
                  
                </div>
      
                <div class="col-12 row m-0 p-0" *ngIf="!showLogin">
      
                    <div class="col-6 col-md mb-2 mt-2"  >
                       
                        <h5 class="font16 semi-bold"  ></h5> 
                   </div>
      
                    <div class="col-6 col-md mb-2 mt-2"  *ngIf="!showLogin">
                        
                        <h5 class="font16 semi-bold" (click) = 'gotologout()' routerLink="/">Logout</h5> 
                   </div>
                   <div class="col-6 col-md mb-2 mt-2"  *ngIf="showLogin">
                       
                       <h5 class="font16 semi-bold"  (click)="navigatee('/login')">Login</h5> 
                  </div>
                      
                </div>
      
                <!-- <div class="col-12 row m-0 p-0">
                    <div class="col-4 col-md mb-2 mt-2 p-0">                      
                        <a class="btn btn-yw-primary mr-2 ml-2" routerLink="/get-started" >SHOP NOW</a>
                    </div>
                </div> -->
      
            </div>
          </div>

          <!-- <a class="btn btn-wp-navbtn getstart mr-2 ml-2" *ngIf="!showLogin" (click) = "gotologout()" href="javascript:void(0)" >LOGOUT</a>
          <a class="btn btn-wpu-navbtn getstart mr-2 ml-2" *ngIf="showLogin" routerLink="/login" href="javascript:void(0)" >LOGIN</a> -->

          <a class="btn btn-wp-primary  mr-2 ml-2 getstart"  *ngIf="!showLogin" href="javascript:void(0)" (click) = "gotologout()">LOGOUT</a>
          <!-- <a class="btn btn-wp-primary  mr-2 ml-2 getstart"  *ngIf="showLogin" href="javascript:void(0)" (click) ="mobileHeaderClick('login')">LOGIN</a> -->

          <!-- <a class="btn btn-pwhite-primary mr-2 ml-2 login" *ngIf="showLogin" routerLink="/login">LOGIN</a>
          <a class="btn btn-pwhite-primary mr-2 ml-2 login" *ngIf="!showLogin" (click) = "logout()">LOGOUT</a> -->

          <a class="btn btn-wpu-navbtn getstart" (click) = "navigate('/commercial/questionnaire')" href="javascript:void(0)" >GET STARTED</a>
         
      </div>
    </nav>
    </div>